import React from "react";
import CloseButton from "@/component/close-button";

const VideoModal = ({ closeModal, videoSrc }) => {
  return (
    <>
      <div className="video--modal">
        <div className="video--modal--header">
          <CloseButton closeFunc={closeModal} />
        </div>

        <div className="video--modal--main">
          <video
            className="video--modal--main--player"
            controls
            autoPlay
            playsInline
          >
            <source src={videoSrc} type="video/mp4"></source>
          </video>
        </div>
      </div>
      <style jsx>
        {`
          .video--modal {
            display: flex;
            flex-direction: column;
            max-width: 100vw;
            height: 100vh;
            width: 100vw;
            @media screen and (min-width: 768px) {
              height: 85vh;
              width: 85vw;
              &--main {
                &--player {
                  max-height: 70vh;
                }
              }
            }
            background-color: white;
            border-radius: 10px;
            padding: 20px;
            &--header {
              display: flex;
              justify-content: flex-end;
            }
            &--main {
              display: flex;
              align-items: center;
              justify-content: center;
              height: 100%
            }
          }
        `}
      </style>
    </>
  );
};

export default VideoModal;
